import React from 'react';
import MapView, { Marker, MapConstant, MapControls, Popup } from '../../../../../lib/Map';
import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { TerminalMarker, ShipmentsMarker } from '../../../../mapComponents/Markers';
import { withAppConfig } from '../../../../../appConfigContext';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import Events from '../../../../../utilities/EventEmitter';
import StyledToolTip from '../../../../common/StyledToolTip';
import appConstant from '../../../../../appConstants';
import DrawStyles from '../../../../../lib/Map/Trimble/components/DrawStyles';
import DrawingTools from '../../../Settings/common/DrawTools/DrawingTools';
import MapDrawingToolBox from '../../../Settings/common/DrawTools/DrawingToolsBox';
import { GeoCode } from '../../../../../layout/layoutHeader/components';
import { ZonePopUpInfo } from '../../../../mapComponents/Popups';
import { getExistingFeaturesGeoJSON } from './utils';

const styles = (theme) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText,
    borderRadius: '4px 4px 0 0',
  },
  label: {
    marginLeft: 6,
    fontWeight: 600
  },
  mapToolBoxStyle: {
    float: 'right',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    height: '19px',
    [theme.breakpoints.down('md')]: {
      padding: '3px 8px'
    }
  },
  mapContainer: { height: 'calc(95% - 15px)' }
});

class EditCustomerMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geoDataList: [],
      zoneInfo: null
    };
  }

  componentDidMount() {
    const { customer, customerGeoFencing } = this.props;
    this.setState({
      geoDataList: getExistingFeaturesGeoJSON({ customer, customerGeoFencing })
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.customerGeoFencing !== prevProps.customerGeoFencing) {
      const { customer, customerGeoFencing } = this.props;
      this.setState({
        geoDataList: getExistingFeaturesGeoJSON({ customer, customerGeoFencing })
      });
    }
  }

  onScaleDrawingComplete = (feature, type) => {
    if ([MapConstant.DRAWING_EVENTS.CREATE, MapConstant.DRAWING_EVENTS.UPDATE].includes(type)) {
      this.props.customerGeoFencingChange(JSON.stringify(feature.geometry.coordinates[0]));
    } else if (type === 'delete') {
      this.props.customerGeoFencingChange(null);
    }
  };

  onMapClicked = () => {
    this.hideAllPopups();
  };

  onZoneClicked = (zoneInfo) => {
    this.setState({ zoneInfo });
  };

  hideAllPopups = () => {
    this.setState({
        zoneInfo: null,
    });
  };

  render() {
    const { theme, customer, classes, customerGeoFencing, glEventHub, gridHeaderId } = this.props;
    this.terminalLocation =
      this.props.userData.userProfile && this.props.userData.userProfile.terminal.location;
    this.mapCenter = {
      lat: customer.latitude,
      lng: customer.longitude
    };
    const stack={ layoutManager: { eventHub: glEventHub } };
    return (
      <>
        <div className={classes.headerStyle}>
          <span className={classes.label}>Customer Map</span>
          <span className={classes.mapToolBoxStyle}> 
            <>
              <GeoCode headerId={gridHeaderId} stack={stack} isEnabled />  
                <MapDrawingToolBox hide={!customer?.deliveryDetails?.customerId} lasso delete />
            </>
          </span>
        </div>
        <div className={classes.mapContainer}>
          <MapView
            zoom={18}
            initialCenter={this.mapCenter}
            onClick={this.onMapClicked}
            mapId={appConstant.mapIds.EDIT_CUSTOMER_MAP}
            mapTheme={theme.themeName}
            satteliteView
            center={this.mapCenter}
            eventHub={this.props.glEventHub}
            mapConfig={this.props.configJSON?.maps}>
            <MapControls
              controlOptions={{
                zoomControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                },
                satelliteViewControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                },
                reCenterMapControl: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
                },
                showZones: {
                  position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  terminalID: this.props.userData.userProfile.terminal.code,
                  onZoneClicked: this.onZoneClicked,
                  geoJson: this.props.userData.userProfile?.geoJson
                }
              }}
            />
            <Marker
              position={this.terminalLocation}
              onClick={this.onTerminalClicked}
              animation
              anchorPoint={{ x: 20, y: 20 }}
              zIndex={1}>
              <TerminalMarker
                data={this.props.userData.userProfile.terminal}
                color={theme.terminalContentColor}
              />
            </Marker>
            {customer ? (
              <Marker
                data={customer}
                position={{
                  lat: customer.latitude,
                  lng: customer.longitude
                }}
                key={`${customer.code}`}
                isActiveShipment={true}
                zIndex={1}>
                <StyledToolTip title={customer.name}>
                  <div>
                    <ShipmentsMarker
                      dimension={'35px'}
                      backgroundColor={theme.commonAppHeaderTabColor}
                      gradientPrimaryColor={theme.gradientPrimaryColor}
                      gradientSecondaryColor={theme.gradientSecondaryColor}
                    />
                  </div>
                </StyledToolTip>
              </Marker>
            ) : null}

            {customer ? (
              <DrawingTools
                singleColorDraw={true}
                polygonOptions={{
                  fillColor: theme.MapDrawingColor,
                  strokeColor: theme.MapDrawingColor
                }}
                geoDataList={this.state.geoDataList}
                styleArray={DrawStyles(theme.commonAppHeaderTabColor)}
                eventHub={Events}
                featureIds={customer?.deliveryDetails?.customerId}
                onDrawingComplete={this.onScaleDrawingComplete}
                mode={customerGeoFencing ? 'create' : 'edit'}
                mapCenter={this.mapCenter}
              />
            ) : null}
            {this.state.zoneInfo && (
              <Popup isCloseButton position={this.state.zoneInfo.position}>
                <ZonePopUpInfo data={this.state.zoneInfo.data} />
              </Popup>
            )}
          </MapView>
        </div>
      </>
    );
  }
}

export { EditCustomerMap };

export default compose(
  withTheme(),
  withStyles(styles),
  withUserProfile,
  withAppConfig
)(EditCustomerMap);
